import { Typography, Box } from '@mui/material';
import { Button } from '@huntington/honeycomb';
import {
	LOCKOUT_DESCRIPTION,
	LOCKOUT_NEW_CODE_BUTTON,
	LOCKOUT_TITLE,
} from '../../../constants/messages';

export default function Lockout() {

	return (
		<Box>
			<Typography
				variant="h1"
				component="h1"
				sx={{
					fontFamily: 'Huntington Serif',
					fontSize: '2.25rem',
					fontWeight: '500',
					marginBottom: '1.5rem',
				}}
			>
				{LOCKOUT_TITLE}
			</Typography>

			<Box>
				<Typography>{LOCKOUT_DESCRIPTION}</Typography>
			</Box>

			<Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '2.5rem' }}>
				<Button>{LOCKOUT_NEW_CODE_BUTTON}</Button>
			</Box>
		</Box>
	);
}
